import { Dispatch } from 'redux';
import DELIVERYADDRESS_CONSTANTS from '../constants/deliveryAddress-constants';
import { AddressModel, ZipCodeResponseModel } from "../../models/address-model";
import { APIDA } from "../api/deliveryAddress-api";

    ///// ADD ADRESS /////
const addAddressBegin = () => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.ADDADDRESS_BEGIN
    };
}

const addAddressSuccess = (data: AddressModel) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.ADDADDRESS_SUCCESS,
        data
    };
}

const addAddressErrors = (e: any) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.ADDADDRESS_ERROR,
        error: e
    };
}

    ///// GET ADDRESS  
const getAddressBegin = () => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.GETADDRESS_BEGIN
    };
}

const getAddressSuccess = (data: AddressModel) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.GETADDRESS_SUCCESS,
        data
    };
}

const getAddressErrors = (e: any) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.GETADDRESS_ERROR,
        error: e
    };
}

//////VERIFY ZIP CODE
const verifyZipBegin = () => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.VERIFYZIP_BEGIN
    };
}

const verifyZipSuccess = (data: ZipCodeResponseModel) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.VERIFYZIP_SUCCESS,
        data
    };
}

const verifyZipErrors = (e: any) => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.VERIFYZIP_ERROR,
        error: e
    };
}

const addAddressClear = () => {
    return {
        type: DELIVERYADDRESS_CONSTANTS.DELIVERYADDRESS_CLEAR
    };
}

export const addAddressAction = (data: AddressModel) => {
    return (dispatch: Dispatch) => {
        dispatch(addAddressBegin());
        APIDA.addAddress(data).then((response: any) => {
            dispatch(addAddressSuccess(response.data));
        }).catch((errors: any) => {
            dispatch(addAddressErrors(errors.response));
        });
    };
}

export const getAddressAction = (id: string) => {
    return (dispatch: Dispatch) => {
        dispatch(getAddressBegin());
        APIDA.getAddress(id).then((response: any) => {
            dispatch(getAddressSuccess(response.data));
        }).catch((errors: any) => {
            dispatch(getAddressErrors(errors.response));
        });
    };
}

export const verifyZipAction = (postalCode: string) => {
    return (dispatch: Dispatch) => {
        dispatch(verifyZipBegin());
        APIDA.verifyPostalCode(postalCode).then((response: any) => {
            dispatch(verifyZipSuccess(response.data));
        }).catch((errors: any) => {
            dispatch(verifyZipErrors(errors.response || errors.message));
        });
    };
}

export const clearAddress = () => {
    return (dispatch: Dispatch) => {
        dispatch(addAddressClear());
    };
}